import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid,
  Tooltip, Legend, ResponsiveContainer
} from 'recharts';

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <Paper sx={{ p: 1, border: '1px solid #ccc' }}>
      <Typography variant="body2" fontWeight="bold">{label}</Typography>
      {payload.map((entry, i) => (
        <div key={i} style={{ color: entry.color }}>{entry.name}: {entry.value}</div>
      ))}
    </Paper>
  );
};

const SnykIncomingTrendChart = ({ data = [] }) => {
  if (!data.length) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" height={300}>
        <Typography color="text.secondary">No data available</Typography>
      </Box>
    );
  }
  return (
    <ResponsiveContainer width="100%" height={300}>
      <AreaChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="period" tick={{ fontSize: 11 }} interval="preserveStartEnd" />
        <YAxis />
        <Tooltip content={<CustomTooltip />} />
        <Legend />
        <Area
          type="monotone"
          dataKey="total"
          name="Incoming Issues"
          fill="#f57c00"
          stroke="#f57c00"
          fillOpacity={0.35}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default SnykIncomingTrendChart;
